var map = {
	"./logo.png": 3153,
	"./分.png": 7956,
	"./尾.png": 3580,
	"./属.png": 7900,
	"./数.png": 418,
	"./正.png": 5065,
	"./段.png": 8399,
	"./波.png": 7152,
	"./特.png": 3235,
	"./生.png": 4773,
	"./码.png": 9451,
	"./禽.png": 9591,
	"./统.png": 5637,
	"./肖.png": 1732,
	"./色.png": 6976,
	"./连.png": 636,
	"./雨.png": 9146
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;